import React, {Component} from 'react'
import Button from "reactstrap/es/Button"
import {getLocalData} from "../../../services/StorageServices";
import {parseJwt} from "../../../share/parseToken";
import BulkRemoveHoldShipModal from './BulkRemoveHoldShipModal';

class BulkRemoveHoldShip extends Component{
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        const {resetBulkAll, reloadItems, closeMenu} = this.props
        const {isOpen} = this.state

        this.setState({
            isOpen: !isOpen
        })

        if(isOpen) {
            resetBulkAll()
            closeMenu()
            reloadItems()
        }
    }

    render() {
        const {isOpen} = this.state
        const token = getLocalData('accessToken')
        const roles = token !== '' && parseJwt(token).roles ? parseJwt(token).roles : []
        const rolesArr = roles.map(role => {
            return role.name
        })

        const {items, selectedItems} = this.props
        const listItems = items.filter(item => selectedItems.includes(item._id))
        const listItemsDisable = listItems.filter(itemH => !itemH.tags.includes('hold-ship'))

        return (
            <div>
                <Button color="link" onClick={this._handleToggleModal} disabled={listItemsDisable.length > 0 ? true : false} className="mr-1">Remove Hold Ship</Button>
                {isOpen && (
                    <BulkRemoveHoldShipModal
                        {...this.props}
                        isOpen={isOpen}
                        roles={rolesArr}
                        handleToggleModal={this._handleToggleModal}
                    />
                )}
            </div>
        );
    }

}

export default BulkRemoveHoldShip